import './upload-image-failure-dialog.scss'

import { PropType } from 'vue';
import Component from "vue-class-component";
import { Watch } from 'vue-property-decorator';
import { BModal } from 'bootstrap-vue';
import { faCircleNotch } from '@fortawesome/free-solid-svg-icons';

import { ReactiveVue } from "@skinsoft/reactive-vue";
import { CANCEL_ALL_IMAGE_UPLOAD, CANCEL_IMAGE_UPLOAD, RETRY_ALL_IMAGE_UPLOAD, RETRY_IMAGE_UPLOAD } from '../../events';

export interface FailedImageUpload {
    mediaUrl: string,
    cacheKey: string,
    info?: string,
    currentlyUploading?: boolean,
}

@Component({
    props: {
        failedImageUploads: {
            type: Array as PropType<FailedImageUpload[]>,
        },
        title: {
            type: String,
            default: "uploadImageFailureDialog.title",
        },
        description: {
            type: String,
            default: "uploadImageFailureDialog.description",
        }
    },
    template: require('./upload-image-failure-dialog.html')
})
export class UploadImageFailureDialog extends ReactiveVue {
    private failedImageUploads: FailedImageUpload[]
    private title: String
    private description: String

    private currentSlideIndex: number = 0

    private loadingIcon = faCircleNotch

    public $refs: {
        modal: BModal,
    }

    private isUploading(index: number): boolean {
        return this.failedImageUploads?.[index]?.currentlyUploading ?? false
    }

    private get someImageCurrentlyUploading(): boolean {
        return this.failedImageUploads.findIndex(failedUpload => {
            return failedUpload.currentlyUploading
        }) > -1
    }

    private get computedDescription(): string {
        return (this.$t(this.description as string, [this.failedImageUploads.length]) ?? this.description) as string
    }

    private onActiveSlideChanged(index: number) {
        this.currentSlideIndex = index
    }

    private onRetryAll() {
        this.$emit(RETRY_ALL_IMAGE_UPLOAD)
    }

    private onCancelAll() {
        this.$emit(CANCEL_ALL_IMAGE_UPLOAD)
    }

    private onRetry(index: number) {
        this.$emit(RETRY_IMAGE_UPLOAD, index)
    }

    private onCancel(index: number) {
        this.$emit(CANCEL_IMAGE_UPLOAD, index)
    }

    public closeModal() {
        this.$refs.modal.hide()
    }

    public openModal() {
        this.$refs.modal.show()
    }

    // Fix a numbering bug when last image is removed (cancel or successfull retry)
    @Watch('failedImageUploads')
    private onFailedImageUploadsChanged() {
        if(this.failedImageUploads.length && this.currentSlideIndex >= this.failedImageUploads.length) {
            this.currentSlideIndex = this.failedImageUploads.length - 1
        }
    }
}